export const SET_VIEW = 'SET_VIEW';

export const FETCH_DATA_PREFIX = 'FETCH_DATA';
export const FETCH_DATA_REQUEST = `${FETCH_DATA_PREFIX}/REQUEST`;
export const FETCH_DATA_SUCCESS = `${FETCH_DATA_PREFIX}/SUCCESS`;
export const FETCH_DATA_FAILURE = `${FETCH_DATA_PREFIX}/FAILURE`;

export const FETCH_METADATA_SUCCESS = 'FETCH_METADATA_SUCCESS';

export const FETCH_USER = 'FETCH_USER';

export const REMOVE_ITEM_PREFIX = 'REMOVE_ITEM';
export const REMOVE_ITEM_REQUEST = `${REMOVE_ITEM_PREFIX}/REQUEST`;
export const REMOVE_ITEM_SUCCESS = `${REMOVE_ITEM_PREFIX}/SUCCESS`;
export const REMOVE_ITEM_FAILURE = `${REMOVE_ITEM_PREFIX}/FAILURE`;
export const REMOVE_ITEM_FROM_STATE = `REMOVE_ITEM_FROM_STATE`;

export const UPDATE_PREFIX = 'UPDATE';
export const UPDATE_REQUEST = `${UPDATE_PREFIX}/REQUEST`;
export const UPDATE_SUCCESS = `${UPDATE_PREFIX}/SUCCESS`;
export const UPDATE_FAILURE = `${UPDATE_PREFIX}/FAILURE`;

export const CREATE_PREFIX = 'CREATE';
export const CREATE_REQUEST = `${CREATE_PREFIX}/REQUEST`;
export const CREATE_SUCCESS = `${CREATE_PREFIX}/SUCCESS`;
export const CREATE_FAILURE = `${CREATE_PREFIX}/FAILURE`;

export const UNSELECT_PRODUCT = 'UNSELECT_PRODUCT';

export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DELETE_PREFIX = 'DELETE';
export const DELETE_REQUEST = `${DELETE_PREFIX}/REQUEST`;
export const DELETE_SUCCESS = `${DELETE_PREFIX}/SUCCESS`;
export const DELETE_FAILURE = `${DELETE_PREFIX}/FAILURE`;

export const SELECT_PRODUCT_PREFIX = 'SELECT_PRODUCT';
export const SELECT_PRODUCT_REQUEST = `${SELECT_PRODUCT_PREFIX}/REQUEST`;
export const SELECT_PRODUCT_SUCCESS = `${SELECT_PRODUCT_PREFIX}/SUCCESS`;
export const SELECT_PRODUCT_FAILURE = `${SELECT_PRODUCT_PREFIX}/FAILURE`;
export const SELECT_CACHED_PRODUCT = 'SELECT_CACHED_PRODUCT';
export const UPDATE_SELECTED_PRODUCT = 'UPDATE_SELECTED_PRODUCT';

export const FETCH_NAVIGATION_PREFIX = 'FETCH_NAVIGATION';
export const FETCH_NAVIGATION_REQUEST = `${FETCH_NAVIGATION_PREFIX}/REQUEST`;
export const FETCH_NAVIGATION_SUCCESS = `${FETCH_NAVIGATION_PREFIX}/SUCCESS`;
export const FETCH_NAVIGATION_FAILURE = `${FETCH_NAVIGATION_PREFIX}/FAILURE`;
export const NO_UBER_TOKEN_ERROR = 'NO_UBER_TOKEN_ERROR';
export const NOT_AUTHORISED_ERROR = 'NOT_AUTHORISED_ERROR';
export const SET_SELECTED_WISHLIST = 'SET_SELECTED_WISHLIST';

export const ADD_ITEM_PREFIX = 'ADD_ITEM';
export const ADD_ITEM_REQUEST = `${ADD_ITEM_PREFIX}/REQUEST`;
export const ADD_ITEM_SUCCESS = `${ADD_ITEM_PREFIX}/SUCCESS`;
export const ADD_ITEM_FAILURE = `${ADD_ITEM_PREFIX}/FAILURE`;

export const ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR = 'ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR';
export const ERR_WISH_LIST_NOT_EXISTS = 'ERR_WISH_LIST_NOT_EXISTS';
export const ERR_WISH_LIST_NAME_ALREADY_EXISTS = 'ERR_WISH_LIST_NAME_ALREADY_EXISTS';
export const ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED = 'ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED';
export const ERR_GIFTLIST_ITEM_NOT_FOUND = 'ERR_GIFTLIST_ITEM_NOT_FOUND';
export const ERR_SKU_ALREADY_EXISTS = 'ERR_SKU_ALREADY_EXISTS';
export const ERR_GENERIC = '_ERR_GENERIC';

export const SHARE = 'SHARE';
export const UNSHARE = 'UNSHARE';
export const CREATE = 'CREATE';
export const RENAME = 'RENAME';
export const REFINE = 'REFINE';

export const CANCEL_MANAGE = 'CANCEL_MANAGE';

export const CLEAR_CACHE = 'CLEAR_CACHE';
export const CLEAR_WISHLIST_ERROR = 'CLEAR_WISHLIST_ERROR';
export const CLEAR_CREATE_ERROR = 'CLEAR_CREATE_ERROR';

export const SET_CONFIG = 'SET_CONFIG';
export const SET_SELECTED_PRODUCT_INDEX = 'SET_SELECTED_PRODUCT_INDEX';

export const MARK_ALERTS_AS_SEEN_PREFIX = 'MARK_ALERTS_AS_SEEN';
export const MARK_ALERTS_AS_SEEN_REQUEST = `${MARK_ALERTS_AS_SEEN_PREFIX}/REQUEST`;
export const MARK_ALERTS_AS_SEEN_SUCCESS = `${MARK_ALERTS_AS_SEEN_PREFIX}/SUCCESS`;
export const MARK_ALERTS_AS_SEEN_FAILURE = `${MARK_ALERTS_AS_SEEN_PREFIX}/FAILURE`;
export const MODAL_RESET_ERROR = 'MODAL_RESET_ERROR';
export const MODAL_CLOSED = 'MODAL_CLOSED';

export * as views from './view';
